// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AdYwm","title":"styles_title__3bXUw"};